import navigationConfig from '../components/SideBar/navigationConfig';

export const getAccessList = () =>
  (localStorage.getItem('access') || '').split(',').filter(Boolean);

export const isSuperAdmin = () => localStorage.getItem('role') === 'Super Admin';

export const hasPermission = (alias) => {
  if (!alias) return true;
  if (isSuperAdmin()) return true;
  return getAccessList().includes(alias);
};

export const hasAnyPermission = (aliases = []) =>
  aliases.some((alias) => hasPermission(alias));

export const canAccessPage = (page) => {
  if (!page || !page.id) return true;
  return hasPermission(page.id);
};

export const getVisiblePages = (pages = []) =>
  pages.filter((page) => canAccessPage(page));

export const getDefaultRoute = () => {
  for (const section of navigationConfig) {
    const visiblePages = getVisiblePages(section.pages);
    if (visiblePages.length > 0) {
      return visiblePages[0].href;
    }
  }
  return '/login';
};
